import { ButtonHTMLAttributes, use } from 'react';

import { Button } from '../Button';

import { FormContext } from './FormContext';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {}

export function Submit(props: Props) {
  const { valid, submitting } = use(FormContext);
  const { disabled, type = 'submit', ...buttonProps } = props;

  return (
    <Button
      {...buttonProps}
      type={type}
      disabled={!valid || submitting || disabled}
      submitting={submitting}
    />
  );
}
